module.exports = __webpack_public_path__ + "static/media/medicare-card-partab-new.ab18f7fe.png";